"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = MainBorderedWindow2;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _MainBorderedWindow2Module = _interopRequireDefault(require("./MainBorderedWindow2.module.scss"));

var _inputElements = require("../../../inputElements");

var _WindowControls = _interopRequireDefault(require("../../WindowControls/WindowControls"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function MainBorderedWindow2(_ref) {
  var pages = _ref.pages,
      _ref$initialPageIndex = _ref.initialPageIndex,
      initialPageIndex = _ref$initialPageIndex === void 0 ? 0 : _ref$initialPageIndex,
      children = _ref.children,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      _ref$contentClassName = _ref.contentClassName,
      contentClassName = _ref$contentClassName === void 0 ? "" : _ref$contentClassName,
      style = _ref.style,
      contentStyle = _ref.contentStyle;
  var contentRef = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(0),
      _useState2 = _slicedToArray(_useState, 2),
      width = _useState2[0],
      setWidth = _useState2[1];

  var _useState3 = (0, _react.useState)(0),
      _useState4 = _slicedToArray(_useState3, 2),
      height = _useState4[0],
      setHeight = _useState4[1];

  var _useState5 = (0, _react.useState)(initialPageIndex),
      _useState6 = _slicedToArray(_useState5, 2),
      currentPageIndex = _useState6[0],
      setCurrentPageIndex = _useState6[1];

  var resizeObserver = (0, _react.useMemo)(function () {
    return new ResizeObserver(function (entry) {
      var contentRect = entry[0].contentRect;
      setWidth(Math.round(contentRect.width) - 40 || 0);
      setHeight(Math.round(contentRect.height) || 0);
    });
  }, []);
  var renderPageControls = (0, _react.useCallback)(function () {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: _MainBorderedWindow2Module.default.pageControls
    }, /*#__PURE__*/_react.default.createElement(_inputElements.Button, {
      type: _inputElements.EButtonType.CMD_LEFT,
      className: _MainBorderedWindow2Module.default.left,
      onClick: function onClick() {
        return setCurrentPageIndex(function (prev) {
          return prev === 0 ? ((pages === null || pages === void 0 ? void 0 : pages.length) || 1) - 1 : prev - 1;
        });
      }
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: _MainBorderedWindow2Module.default.indicator
    }, currentPageIndex + 1), /*#__PURE__*/_react.default.createElement(_inputElements.Button, {
      type: _inputElements.EButtonType.CMD_RIGHT,
      className: _MainBorderedWindow2Module.default.right,
      onClick: function onClick() {
        return setCurrentPageIndex(function (prev) {
          return prev === ((pages === null || pages === void 0 ? void 0 : pages.length) || 1) - 1 ? 0 : prev + 1;
        });
      }
    }));
  }, [currentPageIndex, pages === null || pages === void 0 ? void 0 : pages.length]);
  (0, _react.useLayoutEffect)(function () {
    if (!contentRef.current) {
      return function () {
        /* */
      };
    }

    var c = contentRef.current;
    resizeObserver.observe(c);
    return function () {
      return resizeObserver.disconnect();
    };
  }, [resizeObserver]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_MainBorderedWindow2Module.default.window, pages && _MainBorderedWindow2Module.default.withPages, className),
    style: style
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _MainBorderedWindow2Module.default.row1
  }, /*#__PURE__*/_react.default.createElement(_WindowControls.default, {
    classNameDragHandler: _MainBorderedWindow2Module.default.dragHandler,
    classNameCloseBtn: _MainBorderedWindow2Module.default.closeBtn,
    styleDragHandler: {
      width: width + 28
    },
    styleCloseBtn: {
      marginLeft: width + 28 + 6
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: _MainBorderedWindow2Module.default.topLeft
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: _MainBorderedWindow2Module.default.topCenter,
    style: {
      width: width
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: _MainBorderedWindow2Module.default.topRight
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: _MainBorderedWindow2Module.default.row2
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _MainBorderedWindow2Module.default.borderLeft,
    style: {
      height: height
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    ref: contentRef,
    className: (0, _classnames.default)(_MainBorderedWindow2Module.default.content, contentClassName),
    style: contentStyle
  }, pages ? pages[currentPageIndex] : children), /*#__PURE__*/_react.default.createElement("div", {
    className: _MainBorderedWindow2Module.default.borderRight,
    style: {
      height: height
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: _MainBorderedWindow2Module.default.row3
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _MainBorderedWindow2Module.default.bottomLeft
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: _MainBorderedWindow2Module.default.bottomCenter,
    style: {
      width: width
    }
  }, pages && renderPageControls()), /*#__PURE__*/_react.default.createElement("div", {
    className: _MainBorderedWindow2Module.default.bottomRight
  })));
}